// ============================================================
// THE HOVER CARD on the display (plan design-gaps, T3; the focus page's
// "numbers off the map: wounds, armour and counts live on the hover card"):
// beside the hovered figure's head, a dark card with its side's stripe - its
// name, its wounds, its conditions, how far it is from whoever acts. The
// lines are `hoverCardOf`'s; the figure's <title> stays, for whoever reads it.
// ============================================================

import { SCENE_VIEW } from '../../engine/battlefield/projection';
import type { CardLine, ScreenXY } from './markerGeometry';
import styles from '../../styles/Display.module.css';

/** The card's width, its line height and padding, and how far off the head it stands (scene units). */
const W = 190;
const LINE = 15;
const PAD = 8;
const OFF = { x: 18, y: -40 };

export default function HoverCard({
  id,
  title,
  lines,
  head,
  stripe,
}: {
  id: string;
  title: string;
  lines: CardLine[];
  head: Pick<ScreenXY, 'x' | 'y'>;
  stripe: string;
}) {
  const h = PAD * 2 + LINE * (lines.length + 1);
  // Right of the head and a little above it, kept on the screen.
  const x = Math.min(SCENE_VIEW.width - W - PAD, head.x + OFF.x);
  const y = Math.max(PAD, head.y + OFF.y);
  return (
    <g data-testid={`hover-card-${id}`} className={styles.hoverCard} pointerEvents="none">
      <rect className={styles.hoverCardFace} x={x} y={y} width={W} height={h} rx={3} />
      <rect x={x} y={y} width={3} height={h} fill={stripe} />
      <text className={styles.hoverCardTitle} x={x + PAD + 4} y={y + PAD + 11}>
        {title}
      </text>
      {lines.map((l, i) => {
        const ly = y + PAD + 11 + LINE * (i + 1);
        return (
          <g key={i} className={l.bad ? styles.hoverCardBad : undefined}>
            <text x={x + PAD + 4} y={ly}>
              {l.label}
            </text>
            {l.value && (
              <text className={styles.hoverCardValue} x={x + W - PAD} y={ly} textAnchor="end">
                {l.value}
              </text>
            )}
          </g>
        );
      })}
    </g>
  );
}
